import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import SvgIcon from "@material-ui/core/SvgIcon";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import Button from "components/CustomButtons/Button.jsx";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";
import { dangerColor } from "assets/jss/material-kit-react";

function ErrorIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
        </SvgIcon>
    )
}

class ErrorDialog extends React.Component {
    render(){
        const { classes, onClose, isOpened, } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={onClose}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={onClose}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Ошибка!</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <ErrorIcon style={{fontSize: "11em", display: "block", marginLeft: "auto", marginRight: "auto",
                        marginTop:"0.5em", marginBottom: "0.7em", color: dangerColor}}/>
                    <p>Проверьте правильность введенных данных или попробуйте позже.</p>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" simple
                            onClick={onClose}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

ErrorDialog.propTypes = {
    isOpened: PropTypes.bool,
    onClose: PropTypes.func,
};

export default withStyles(modalStyle)(ErrorDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/ErrorDialog.jsx